export default __webpack_public_path__ + "static/media/photo-1546820389-44d77e1f3b31.879865ae.jpeg";